module.exports = class {
    onMount() {
        // TODO: implement any subscriptions here
    }
};
